export { default as ListView } from 'notifications_config/components/NotificationsConfigListView';
export { default as FormView } from 'notifications_config/components/NotificationConfigFormView';
export { default as Row } from 'notifications_config/components/list/NotificationsConfigListRow';



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/components/index.js